import axios from "axios";

export const requestCaptureReferralDetails = (data) =>
  axios.post("api/route?path=referral/capture-details", data);
